<template>
    <header class="header d-blue-bg">
        <!-- Header Top -->
        <div class="header-top">
            <div class="container">
                <div class="header-inner">
                    <div class="row align-items-center">
                        <div class="col-xl-6 col-lg-7">
                            <div class="header-inner-start">
                                <div class="header__currency border-right">
                                    <div class="s-name">
                                        <span>Language: </span>
                                    </div>
                                    <ui-nice-select :options="[
                                        { value: 'english', text: 'English' },
                                        { value: 'deutsch', text: 'Deutsch' },
                                        { value: 'french', text: 'Français' },
                                        { value: 'spanish', text: 'Espanol' }
                                    ]" name="Language" :default-current="0" />
                                </div>
                                <div class="header__lang border-right">
                                    <div class="s-name">
                                        <span>Currency: </span>
                                    </div>
                                    <ui-nice-select :options="[
                                        { value: 'usd', text: 'USD' },
                                        { value: 'eur', text: 'EUR' },
                                        { value: 'inr', text: 'INR' },
                                        { value: 'bdt', text: 'BDT' },
                                        { value: 'bgd', text: 'BGD' }
                                    ]" name="Currency" :default-current="0" />
                                </div>
                                <div class="support d-none d-sm-block">
                                    <p>Need Help? <a to="tel:+001123456789">+001 123 456 789</a></p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-5 d-none d-lg-block">
                            <div class="header-inner-end text-md-end">
                                <div class="ovic-menu-wrapper">
                                    <ul>
                                        <li><router-link to="/about">About Us</router-link></li>
                                        <li><router-link to="/contact">Order Tracking</router-link></li>
                                        <li><router-link to="/contact">Contact Us</router-link></li>
                                        <li><router-link to="/faq">FAQs</router-link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- header mid -->

        <div class="header-mid">
            <div class="container">
                <div class="header-mid-inner">
                    <div class="row align-items-center">
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                            <div v-if="!style_3" class="header__info">
                                <div class="logo">
                                    <router-link to="/" class="logo-image">
                                        <img :src="logo" alt="logo">
                                    </router-link>
                                </div>
                            </div>
                            <div v-if="style_3" class="header__info header__info-2">
                                <div class="logo logo-3">
                                    <router-link to="/" class="logo-image">
                                        <img src="/images/logo/logo1.svg" alt="logo">
                                    </router-link>
                                </div>
                                <div class="side-menu mr-20">
                                    <button @click="handleOpenSidebar" type="button"
                                        class="side-menu-btn offcanvas-toggle-btn"><i class="fas fa-bars"></i></button>
                                </div>
                            </div>

                        </div>

                        <div class="col-xl-5 col-lg-4 d-none d-lg-block">
                            <div class="header__search">
                                <form @submit.prevent="handleSubmit">
                                    <div class="header__search-box">
                                        <input :class="`search-input ${style_2 ? 'search-input-2' : ''}`" type="text"
                                            placeholder="I'm shopping for..." v-model="searchText" />
                                        <button
                                            :class="`button ${style_2 ? 'button-2' : ''} ${style_3 ? 'button-3' : ''}`"
                                            type="submit">
                                            <i class="fas fa-search"></i>
                                        </button>
                                    </div>
                                    <div class="header__search-cat">
                                        <ui-nice-select :options="category_options" name="Category" :default-current="0"
                                            @onChange="changeHandler" />
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-5 col-md-8 col-sm-8">
                            <div class="header-action">
                                <div class="block-userlink">
                                    <router-link :class="`icon-link ${style_2 ? 'icon-link-2' : ''}`" v-if="isLoggedIn"
                                    to="/my-account">
                                        <i class="flaticon-user"></i>
                                        <span class="text">
                                            <span class="sub">Welcome, </span>
                                            {{ user.name }} <!-- Show logged-in user's name -->
                                        </span>
                                    </router-link>
                                    <router-link :class="`icon-link ${style_2 ? 'icon-link-2' : ''}`" v-else
                                    to="/login">
                                        <i class="flaticon-user"></i>
                                        <span class="text">
                                            <span class="sub">Login </span>
                                        </span>
                                    </router-link>
                                </div>
                                <div class="block-wishlist action">
                                    <router-link :class="`icon-link ${style_2 ? 'icon-link-2' : ''}`" to="/wishlist">
                                        <i class="flaticon-heart"></i>
                                        <!--
                                        <span :class="`count ${style_2 ? 'count-2' : ''}`">
                                            {{ wishlistStore.wishlists.length }}
                                        </span>
                                        -->
                                        <span class="text">
                                            <span class="sub">Favorite</span>
                                            My Wishlist
                                        </span>
                                    </router-link>
                                </div>
                                <div class="block-cart action">
                                    <router-link :class="`icon-link ${style_2 ? 'icon-link-2' : ''}`" to="/cart">
                                        <i class="flaticon-shopping-bag"></i>

                                        <span :class="`count ${style_2 ? 'count-2' : ''}`">
                                            {{ cartStore.totalPriceQuantity.quantity }}
                                        </span>
                                        <span class="text">
                                            <span class="sub">Your Cart:</span>
                                            ${{ cartStore.totalPriceQuantity.total.toFixed(2) }}
                                        </span>
                                    </router-link>
                                    <div class="cart">
                                        <!-- mini cart -->
                                        <header-cart-mini />
                                        <!-- mini cart -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- header mid -->

        <div class="header__bottom">
            <div class="container">
                <div class="row g-0 align-items-center">
                    <div class="col-lg-3">
                        <div class="cat__menu-wrapper side-border d-none d-lg-block">
                            <div class="cat-toggle">
                                <button @click="cate_menu = !cate_menu" type="button"
                                    class="cat-toggle-btn cat-toggle-btn-1">
                                    <i class="fas fa-bars"></i> Shop by department
                                </button>
                                <div class="cat__menu" v-if="cate_menu">
                                    <nav id="mobile-menu">
                                        <!-- Header Category -->
                                        <header-category :categories="category_data"></header-category>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-3">
                        <div class="header__bottom-left d-flex d-xl-block align-items-center">
                            <div class="side-menu d-lg-none mr-20">
                                <button @click="isSidebarOpen = !isSidebarOpen" type="button"
                                    class="side-menu-btn offcanvas-toggle-btn">
                                    <i class="fas fa-bars"></i>
                                </button>
                            </div>
                            <div class="main-menu d-none d-lg-block">
                                <!-- Header Nav Menus -->
                                <header-nav-menu></header-nav-menu>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-9">
                        <div class="shopeing-text text-sm-end">
                            <p>Spend $120 more and get free shipping!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="header__bottom d-none d-lg-block">
            <div class="container">
                <div class="box-items-inner pt-10 pb-10">
                    <div v-for="(item, i) in category_data" :key="item.id" class="box-item"
                        :class="{ 'd-lg-none d-xl-block': isLastItem(i) }">
                        <router-link :to="`/search?category=${item.id}`">
                            <i :class="item.icon"></i>
                            <div v-html="renderCategoryName(item.cat_name)"></div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import logo from '@/assets/logo/logo1.svg'
import HeaderNavMenu from '@/components/test/HeaderNavMenu.vue'
import UiNiceSelect from '@/components/ui/nice-select.vue'
import HeaderCartMini from '@/components/test/header-cart-mini.vue'
import { useCartStore } from '@/stores/useCartStore'
import { ref, computed } from 'vue'

export default {
    components: {
        HeaderNavMenu,
        UiNiceSelect,
        HeaderCartMini
    },
    name: "HeaderOne",
    setup() {
        // Getting user data from localStorage
        const user = ref(JSON.parse(localStorage.getItem('user')) || null) // Get user from localStorage
        const isLoggedIn = computed(() => {
            return !!user.value // Check if the user data exists
        })
        const cartStore = useCartStore()

        return {
            user,
            isLoggedIn,
            cartStore,
            logo,
        }
    },
    data() {
        return {
            cate_menu: false,
            isSidebarOpen: false,
            category_data: [],
            searchText: '',
            category_value: '',
            category_options: [],
        }
    },
    methods: {
        async fetchCategories() {
            try {
                const response = await this.$axios.get('/top-categories')
                this.category_data = response.data.rows
                console.log(response.data)

                // Populate category options after fetching categoriess
                this.category_options = this.category_data.map(item => {
                    return { value: item.cat_id, text: item.cat_name } // Use cat_id as value
                })
                this.category_options.unshift({ value: "all", text: "All Category" })
            } catch (error) {
                console.error("Error fetching categories:", error)
            }
        },

        renderCategoryName(name) {
            return name.replace('&', '<br/> &')
        },
        isLastItem(index) {
            return index === this.category_data.length - 1
        },
        formatUrl(slug) {
            return slug.replace(/\s+/g, '-').toLowerCase() // Example implementation
        },
    },
    mounted() {
        this.fetchCategories()
    }
}
</script>
